<template>

    <div class="user">
        <!--添加任务-->
        <div class="common-seach-wrap">
            <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
                <el-form-item label="产品名称">
                    <el-input placeholder="请输入产品名称" v-model="formInline.search">

                    </el-input>
                </el-form-item>

                <el-form-item label="审核情况">
                <el-select v-model="formInline.audit" placeholder="请选择">
                    <el-option label="全部" :value="0"></el-option>
                    <el-option label="待审核" :value="1"></el-option>
                    <el-option label="审核通过" :value="2"></el-option>
                    <el-option label="审核未通过" :value="3"></el-option>
                </el-select>
             </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>
                    <el-button type="primary" icon="el-icon" v-if="is_back" @click="back">返回上一页</el-button>
                </el-form-item>

            </el-form>
        </div>

        <div class="common-level-rail">
            <el-button size="small" icon="el-icon-plus" v-if="isuse == 0" type="primary" @click="addClick">添加产品</el-button>

            <el-button size="small" icon="el-icon"  v-if="isuse == 0" style="background: #ff8227;border: 1px solid #ff8227;" type="primary" @click="importProduct">商品导入</el-button>

            <el-button size="small" icon="el-icon"  v-if="isuse == 0"  style="background: #654efc;border: 1px solid #654efc;" type="primary" @click="exportProduct">商品导出</el-button>
        </div>

        <div class="product-content">
            <el-form ref="form" :model="form" label-width="100px">
                <div class="table-wrap">
                    <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">

                        <el-table-column prop="name" label="产品名称"></el-table-column>
                        <el-table-column prop="category.name" label="产品分类"></el-table-column>

                        <el-table-column prop="image" label="产品图片">
                            <template slot-scope="scope">
                                <div v-if="scope.row.image">

                                    <el-image
                                        :src="scope.row.image"
                                        :preview-src-list="[scope.row.image]"
                                        style="width: 30px; height: 30px;"
                                        fit="cover"
                                    ></el-image>

                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="price" label="价格"></el-table-column>


                        <el-table-column prop="is_standard" label="类型">
                            <template slot-scope="scope">
                                <div v-text="scope.row.is_standard == 0?'标品' : '定制'"></div>
                            </template>

                        </el-table-column>

                        <!-- <el-table-column prop="intro" label="产品介绍">
                            <template slot-scope="scope">
                                <el-button style="margin-left: 0px !important;margin-right: 10px;"
                                    @click="introClick(scope.row,'intro')" type="text" size="small">产品介绍</el-button>
                            </template>
                        </el-table-column> -->
                        <el-table-column prop="statusName" label="审核状态"></el-table-column>
                        <el-table-column prop="fview" label="虚拟浏览量"></el-table-column>
                        <el-table-column prop="view" label="浏览量"></el-table-column>
                        <el-table-column prop="sort" label="排序"></el-table-column>
                        <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
                        <el-table-column fixed="right" label="上架/下架" width="150">
                            <template slot-scope="scope">
                                <el-switch
                                    :disabled="scope.row.status == 3 || scope.row.status == 1" active-text="上架"
                                    v-model="scope.row.release"
                                    :active-value="1"
                                    :inactive-value="0"
                                    inactive-text="下架" @change="handleBlur(scope.row,'release')">
                                </el-switch>
                            </template>
                        </el-table-column>
                        <el-table-column fixed="right" label="操作" width="190">
                            <template slot-scope="scope">
                                <el-button @click="authClick(scope.row)"

                                  v-auth="'/plus/hproduct/index/auth'"
                                type="text" size="small">权限</el-button>
                                <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
                                <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
                                <el-button @click="passClick(scope.row)" type="text" size="small"
                                    v-if="scope.row.status == 1"
                                    v-auth="'/plus/hproduct/index/auditPass'"
                                    >审核通过</el-button>
                                <el-button @click="nopassClick(scope.row)" type="text" size="small"
                                    v-if="scope.row.status == 1"
                                       v-auth="'/plus/hproduct/index/auditNoPass'"
                                    >审核不通过</el-button>
                                <!-- <el-button @click="checkRecord(scope.row)" type="text" size="small">查看变更记录</el-button> -->
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-form>
            <!--分页-->
            <div class="pagination">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
                    :current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next, jumper"
                    :total="totalDataNumber"></el-pagination>
            </div>
        </div>

        <Add :open_add="open_add" v-if="open_add" @close="closeAdd"></Add>
        <Edit :open_add="open_edit" :hproduct_id="hproduct_id" v-if="open_edit" @close="closeEdit"></Edit>
        <Record :open_add="open_record" :rid="recordid" v-if="open_record" @close="closeAdd"></Record>
        <el-dialog style="text-align: center" title="设置标题" :visible.sync="dialogVisible" @close='dialogFormVisible'
            :close-on-click-modal="false" :close-on-press-escape="false" :append-to-body="true">
        </el-dialog>
        <Tz :open_add="open_tz" :code="code" :hproduct_id="hproduct_id" :obj="obj" v-if="open_tz" @close="closeTz"></Tz>
        <Auth :open_add="is_auth" :obj="obj" :hproduct_id="hproduct_id"  v-if="is_auth" @close="closeAuth"></Auth>

        <Upload v-if="open_upload" :open_upload="open_upload" :import_type="import_type"  @closeDialog="closeDialogFunc($event,'upload')"></Upload>
    </div>
</template>

<script>
    import HproductApi from '@/api/hproduct.js';
    import Add from './part/add.vue';
    import Edit from './part/edit.vue';
    import Tz from './part/tz.vue';
    import Record from './part/record.vue';
    import Auth from './part/auth.vue';
    import Upload from '@/components/file/import';
    import qs from 'qs';
    import { getCookie } from '@/utils/base';
    export default {
        components: {
            Add,
            Edit,
            Tz,
            Record,
            Auth,
            Upload
        },
        inject: ['reload'],
        data() {
            return {
                import_type:'hproduct',
                /*是否加载完成*/
                loading: true,
                /*列表数据*/
                tableData: [],
                /*一页多少条*/
                pageSize: 20,
                /*一共多少条数据*/
                totalDataNumber: 0,
                /*当前是第几页*/
                curPage: 1,
                /*搜索表单对象*/
                form: {},
                formInline: {
                    search: "",
                    audit:0,
                },
                value1: true,
                open_add: false,
                open_edit: false,
                hproduct_id: "",
                dialogVisible: false,
                open_tz: false,
                open_record: false,
                obj: {},
                recordid: "",
                is_auth:false,
                is_back:false,
                open_upload:false,
                isuse:0,
            };
        },
        created() {

                  var self = this;
            self.getInas({},function(res){
                self.isuse = res
            })

            if(this.$route.query.status){
                this.formInline.audit = this.$route.query.status;
                this.is_back = true;
            }
            /*获取列表*/
            this.getTableList();
        },
        methods: {
              /*关闭弹窗*/
            closeDialogFunc(e, f) {
                if (f == 'upload') {
                    this.open_upload = e.openDialog;
                    if (e.type == 'success') {
                        this.getTableList();
                    }
                }
            },
            importProduct(){
                this.open_upload = true;
            },
            exportProduct(){
                let baseUrl = window.location.protocol + '//' + window.location.host;
                window.location.href = baseUrl + '/index.php/shop/order.operate/exportHproduct?' + qs.stringify(this.formInline);
            },
            back(){
                this.$router.back(-1);
            },
            authClick(item){
                this.hproduct_id = item.hproduct_id
                this.obj = item;
                this.is_auth = true;
            },
            closeAuth(item){
                this.getTableList();
                this.is_auth = false;
            },
            async nopassClick(item) { //退款申请-不通过审核
                var self = this;
                const reject_val = await this.promptInput('请输入不通过的原因',
                    '请输入不通过的原因');
                console.log(reject_val)
                let datas = {}
                datas.hproduct_id = item.hproduct_id
                datas.app_id = item.app_id
                datas.status = 3
                datas.audit_remark = reject_val
                HproductApi.examine(datas, true).then(res => {
                    if (res.code == 1) {
                        console.log(res)
                        if(res.code == 1){
                            this.$message({
                                message: res.msg,
                                type: 'success'
                            });
                            setTimeout(() => {
                                self.getData()
                            },1000)
                        }

                    }
                })
            },


            // 审核通过
            passClick(e) {
                let that = this
                let datas = {}
                datas.hproduct_id = e.hproduct_id
                datas.app_id = e.app_id
                datas.status = 2
                datas.audit_remark = ''
                HproductApi.examine(datas, true).then(res => {
                    if (res.code == 1) {
                        console.log(res)
                        if(res.code == 1){
                            this.$message({
                                message: res.msg,
                                type: 'success'
                            });
                            setTimeout(() => {
                                that.getData()
                            },1000)
                        }

                    }
                })


            },
            // 审核不通过
            // nopassClick() {

            // },
            handleBlur(row,key){
        var self = this;
        HproductApi.editParts(
              {
                hproduct_id: row.hproduct_id,
                cond:[
                {
                  'key':key,
                  'val':row[key]
                }
                ]
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '修改成功',
                    type: 'success'
                  });

                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });

      },

            closeTz(e) {
                this.open_tz = false;

                this.getTableList();
            },
            // 查看变更记录
            checkRecord(e) {
                console.log(e)
                let that = this
                that.recordid = e.hproduct_id
                that.open_record = true
            },
            introClick(row, code) {
                this.open_tz = true;
                this.obj = row
                this.code = code
                this.hproduct_id = row.hproduct_id;
            },
            dialogFormVisible() {
                this.dialogVisible = false;
            },
            setting(e) { //产品标题设置
                // this.categorya_id = e
                this.dialogVisible = true;
            },
            /*关闭添加*/
            closeAdd(e) {
                this.open_add = false;
                this.open_record = false
                this.getTableList();
            },
            closeEdit(e) {
                this.open_edit = false;
                this.getTableList();
            },
            getData() {
                this.getTableList();
            },
            /*选择第几页*/
            handleCurrentChange(val) {
                this.curPage = val;
                this.getTableList();
            },

            /*每页多少条*/
            handleSizeChange(val) {
                this.curPage = 1;
                this.pageSize = val;
                this.getTableList();
            },

            /*获取列表*/
            getTableList() {
                let supply = sessionStorage.getItem("supply")?JSON.parse(sessionStorage.getItem("supply")):null;
                console.log("qqq");
                console.log(supply);
                let self = this;
                let Params = this.formInline;
                Params.page = self.curPage;
                Params.list_rows = self.pageSize;
                if(supply&&supply.supply_id){
                    Params.supply_id = supply.supply_id;
                }

                self.loading = true;
                HproductApi.list(Params, true)
                    .then(data => {
                        console.log("data", data)
                        data.data.list.data.forEach((v, i) => {
                            v.statusName = v.status == 1 ? '待审核' : v.status == 2 ? "已通过" : v.status == 3 ?
                                '未通过' : v.status == 5 ? "已上架" : '已下架'

                        })
                        self.loading = false;
                        self.tableData = data.data.list.data;
                        self.totalDataNumber = data.data.list.total;
                        if(supply&&supply.supply_id){
                            self.tableData.map((item)=>{
                                if(!!item.supplyArray){
                                    let array = JSON.parse(item.supplyArray);
                                    let index = array.findIndex((it)=>it.supply_id==supply.supply_id);
                                    if(index>=0){
                                        item.price=array[index].price;
                                    }
                                }

                            });
                        }else{
                            self.tableData.map((item)=>{
                                if(!!item.supplyArray){
                                    let array = JSON.parse(item.supplyArray);
                                    let minPrice = array.reduce((min, item) => Math.min(min, item.price), array[0].price);
                                    item.price=minPrice;
                                }
                            });
                        }
                    })
                    .catch(error => {});
            },
            async promptInput(message, validation) {
              try {
                const { value } = await this.$prompt(message, '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  inputErrorMessage: validation,
                });
                return value.trim();
              } catch(e) {
                this.$message({
                  type: 'info',
                  message: '取消输入',
                });
              }
            },
            /*搜索查询*/
            onSubmit() {
                this.curPage = 1;
                this.getTableList();
            },

            /*添加任务*/
            addClick() {
                this.open_add = true
            },

            /*编辑活动*/
            editClick(row) {
                this.hproduct_id = row.hproduct_id;
                this.open_edit = true
            },

            /*删除*/
            deleteClick(row) {
                let self = this;
                self
                    .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    })
                    .then(() => {
                        HproductApi.del({
                                    hproduct_id: row.hproduct_id
                                },
                                true
                            )
                            .then(data => {
                                if (data.code == 1) {
                                    self.$message({
                                        message: '删除成功',
                                        type: 'success'
                                    });
                                    this.getTableList();
                                } else {
                                    self.$message.error('错了哦，这是一条错误消息');
                                }
                            })
                            .catch(error => {});
                    })
                    .catch(() => {});
            }
        }
    };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/hproduct/index/index.vue